"use client";

import type { ReactNode } from "react";
import { SuggestedThoughtConfirmationProvider } from "@/features/thoughts";
import { StudioConfirmationProvider } from "./StudioConfirmationProvider";
import { StudioDeletionStateProvider } from "./StudioDeletionStateProvider";
import { StudioHandlersProvider } from "./StudioHandlersProvider";
import { StudioReassignStateProvider } from "./StudioReassignStateProvider";

export function StudioContextProvider({ children }: { children: ReactNode }) {
  return (
    <SuggestedThoughtConfirmationProvider>
      <StudioConfirmationProvider>
        <StudioReassignStateProvider>
          <StudioDeletionStateProvider>
            <StudioHandlersProvider>{children}</StudioHandlersProvider>
          </StudioDeletionStateProvider>
        </StudioReassignStateProvider>
      </StudioConfirmationProvider>
    </SuggestedThoughtConfirmationProvider>
  );
}
